import { render, staticRenderFns } from "./DrugAllocation.vue?vue&type=template&id=f6db0b78&"
import script from "./DrugAllocation.vue?vue&type=script&lang=js&"
export * from "./DrugAllocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports